import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const GridIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M27 7V14.5C27 14.6326 26.9473 14.7598 26.8536 14.8536C26.7598 14.9473 26.6326 15 26.5 15H17V5.5C17 5.36739 17.0527 5.24021 17.1464 5.14645C17.2402 5.05268 17.3674 5 17.5 5H25C25.5304 5 26.0391 5.21071 26.4142 5.58579C26.7893 5.96086 27 6.46957 27 7ZM14.5 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V14.5C5 14.6326 5.05268 14.7598 5.14645 14.8536C5.24021 14.9473 5.36739 15 5.5 15H15V5.5C15 5.36739 14.9473 5.24021 14.8536 5.14645C14.7598 5.05268 14.6326 5 14.5 5ZM26.5 17H17V26.5C17 26.6326 17.0527 26.7598 17.1464 26.8536C17.2402 26.9473 17.3674 27 17.5 27H25C25.5304 27 26.0391 26.7893 26.4142 26.4142C26.7893 26.0391 27 25.5304 27 25V17.5C27 17.3674 26.9473 17.2402 26.8536 17.1464C26.7598 17.0527 26.6326 17 26.5 17ZM5 17.5V25C5 25.5304 5.21071 26.0391 5.58579 26.4142C5.96086 26.7893 6.46957 27 7 27H14.5C14.6326 27 14.7598 26.9473 14.8536 26.8536C14.9473 26.7598 15 26.6326 15 26.5V17H5.5C5.36739 17 5.24021 17.0527 5.14645 17.1464C5.05268 17.2402 5 17.3674 5 17.5Z" />
  </svg>
);

GridIcon.propTypes = iconPropTypes;

export default GridIcon;
